import AuthToken from 'sr/models/Auth'
import {post} from 'sr/utils/axios/index'
import {toast} from 'react-toastify'

const logoutUser = async (_refreshToken?: string) => {
  try {
    return await post<any>('/admin/auth/logout', {}).then((user) => {
      if (user) {
        return user
      }
      return null
    })
  } catch (e: any) {
    toast.error(e.message)
    return null
  }
}

export default logoutUser
